import React, { Component } from "react";
import { connect } from "react-redux";
import Counter from "../../Tool/Counter/Counter";
import ColorPicker from "../../Tool/ColorPicker/ColorPicker";
import * as actionTypes from "../../../store/Actions/actions";
import { Col } from "reactstrap";
import "./Line.scss";
import { SketchPicker } from "react-color";
import cloneDeep from "lodash.clonedeep";
import Popup from "../../Modal/Popup";
import * as UTILS from "../../../utils/Utils";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";

class LineModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editLine: false,
      colorPicker: false,
      color: "",
    };
  }
  componentDidMount = () => {
    this.getTimerVal;
  };
  counterChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlus = (value, property) => {
    const layout = cloneDeep(this.props.layout);

    const selectedValue = value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value > 1 ? value : "1";
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  unitValueChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  borderColorChange = (value) => {
    const layout = cloneDeep(this.props.layout);

    const selectedValue = value.rgb;
    const hexValue = value.hex;

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style.backgroundColor = {};
        item.style.backgroundColor = selectedValue;
      },
      (colItem) => {
        colItem.style.backgroundColor = {};
        colItem.style.backgroundColor = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style.backgroundColor = {};
        colItemNested.style.backgroundColor = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  addDividerLabel = (event) => {
    /* signal to React not to nullify the event object */
    event.persist();

    const layout = cloneDeep(this.props.layout);
    const selectedValue = event.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.label = selectedValue;
      },
      (colItem) => {
        colItem.label = selectedValue;
      },
      (colItemNested) => {
        colItemNested.label = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  render() {
    return (
      <Popup
        width="700"
        header="Divider settings"
        closePopup={this.props.hideLineSetting}
        close={this.props.hideLineSetting}
        // save={this.chooseTemplate}
        // btnLabel="Select"
        // parentID="lineWrap"
        parentID="lineSetting"
      >
        <div className="lineSetting modalScrollContainerSecondary">
          <div className="modalContentWrapper">
            <label>
              Divider Label <small> (For Meta Data and Aria Labels)</small>
            </label>
            <input
              onChange={this.addDividerLabel}
              defaultValue={this.props.label}
              placeholder="Add Divider Label"
              className="imageLabelInput"
              type="text"
            />
          </div>

          <div
            style={{ marginTop: "10px", marginBottom: "20px" }}
            className="padding-section"
          >
            <div className="heading">Border</div>
          </div>
          <div className="modalContentWrapper">
            <div
              style={{ display: "flex", flexDirection: "row", width: "100%" }}
            >
              <Counter
                label="Width"
                minusClick={() =>
                  this.counterMinus(this.props.borderWidth, "borderWidth")
                }
                valueContent={this.props.borderWidth}
                disabled={false}
                onChange={(e) => {
                  this.counterChange(e, "borderWidth");
                }}
                plusClick={() =>
                  this.counterPlus(this.props.borderWidth, "borderWidth")
                }
              />
              <div
                style={{
                  width: "300px",
                  paddingTop: "22px",
                  marginLeft: "20px",
                }}
              >
                <ColorPicker
                  btnLabel="Border Color"
                  colorValue={this.props.backgroundColor}
                  colorDefaultValue={{ r: 252, g: 252, b: 252, a: 0 }}
                  getColor={(e) => {
                    this.borderColorChange(e);
                  }}
                />
              </div>
            </div>
          </div>

          <div
            style={{ marginTop: "30px", marginBottom: "5px" }}
            className="padding-section"
          >
            <div className="heading">Margin</div>
          </div>

          <div className="modalContentWrapper">
            <div className="">
              <div
                className="heading-row"
                style={{ justifyContent: "flex-end" }}
              >
                <UnitSelector
                  value={
                    this.props.lineMarginUnit ? this.props.lineMarginUnit : "px"
                  }
                  onChange={(e) => {
                    this.unitValueChange(e, "lineMarginUnit");
                  }}
                />
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row",width:'50%' }}>
              <div className="d-block">
                <Counter
                  label="Margin Top"
                  small={
                    this.props.lineMarginUnit === "%" ? "percent" : "pixel"
                  }
                  minusClick={() =>
                    this.counterMinus(this.props.marginTop, "marginTop")
                  }
                  valueContent={this.props.marginTop}
                  disabled={false}
                  onChange={(e) => {
                    this.counterChange(e, "marginTop");
                  }}
                  plusClick={() =>
                    this.counterPlus(this.props.marginTop, "marginTop")
                  }
                />
              </div>

              <div className="d-block">
                {" "}
                <Counter
                  label="Bottom"
                  small={
                    this.props.lineMarginUnit === "%" ? "percent" : "pixel"
                  }
                  minusClick={() =>
                    this.counterMinus(this.props.marginBottom, "marginBottom")
                  }
                  valueContent={this.props.marginBottom}
                  disabled={false}
                  onChange={(e) => {
                    this.counterChange(e, "marginBottom");
                  }}
                  plusClick={() =>
                    this.counterPlus(this.props.marginBottom, "marginBottom")
                  }
                />
              </div>
            </div>
          </div>
          <div className="clearboth"></div>
        </div>
      </Popup>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LineModal);
